import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';

export default function ConfiguringGoogleSheets() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Configuring Your Data&nbsp;Source: Google Sheets
      </Typography>

      <Typography paragraph>
        Follow these two steps:
      </Typography>

      <List className="steps-vertical" sx={{ ml: '2rem' }}>
        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            1&nbsp;·&nbsp;Paste the sheet&nbsp;URL. Make sure it’s in the
            signed-in Google account (or share it with the PostSheet service user).
          </Typography>
          <img
            src="../../static/docs/SelectUrl.jpg"
            alt="Enter Google Sheets URL"
            className="step-img"
          />
        </ListItem>

        <ListItem sx={{ ml: '1rem' }}>
          <Typography variant="h4">
            2&nbsp;·&nbsp;When PostSheet reads the sheet successfully,
            the&nbsp;<strong>Next</strong> button activates and the status badge turns green;
            otherwise, an error is displayed.
          </Typography>
          <img
            src="../../static/docs/UrlPasted.jpg"
            alt="Google Sheets URL validated"
            className="step-img"
          />
        </ListItem>
      </List>
    </Box>
  );
}